import React, { type ReactNode, useLayoutEffect } from 'react';

import { useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';

import { useAnalyticsEvents } from '../../common/analytics/generated/use-analytics-events';
import { useMessagesForLocation } from '../../common/utils/use-messages-for-location';

import { GenericErrorIcon } from './icon';

export function ErrorBoundaryUI({
	errorFallbackUI,
	errorActionUI,
	location,
}: {
	errorActionUI?: ReactNode;
	errorFallbackUI?: ReactNode;
	location?: string;
}) {
	const intl = useIntl();
	const { fireEvent } = useAnalyticsEvents();
	const { header, description } = useMessagesForLocation(location);

	useLayoutEffect(() => {
		fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
			isFallbackUI: !!errorFallbackUI,
		});
	}, [errorFallbackUI, fireEvent]);

	// If a custom fallback UI is provided, render it directly at risk of consumer
	if (errorFallbackUI) {
		return errorFallbackUI;
	}

	return (
		<EmptyState
			testId="navigation-error-boundary-ui"
			header={intl.formatMessage(header)}
			description={intl.formatMessage(description)}
			headingLevel={4}
			headingSize="medium"
			primaryAction={errorActionUI}
			renderImage={() => <GenericErrorIcon />}
		/>
	);
}
